import { useState } from 'react';
import useDidMountEffect from 'assets/js/useDidMountEffect';

/* 이미지 */
import HeadLogo from 'assets/img/cover-header.webp';
import FootLogo from 'assets/img/cover-logo.webp';

export default function ReportCover(props) {
  const [targetDate, setTargetDate] = useState('');

  useDidMountEffect(() => {
    if (props?.targetDate !== undefined && props?.targetDate !== null && typeof props?.targetDate === 'string') {
      const date = new Date(props.targetDate);

      const year = date.getFullYear();
      const month = date.getMonth();

      const monthStr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',];

      setTargetDate(monthStr[month] + ' ' + year);
    }
  }, [props])

  return (
    <div className='page cover'>
      <div className='cover-head'>
        <img src={HeadLogo || ''} alt='ust-logo'/>
      </div>
      <div className='cover-content'>
        <div className='head'>
          <h4>CUSTOMER REPORT</h4>
          <textarea readOnly defaultValue={targetDate}/>
        </div>
        <textarea readOnly defaultValue={props.clientName}/>
      </div>
      <div className='cover-foot'>
        <div className='img-box'>
          <img src={FootLogo || ''} alt='ust-logo'/>
        </div>
        <div className='desc-box'>
          <p>
            UST prepares for the future and the well-being of its
            customers with systematic approach and technology
            for pest free environment
          </p>
          <ul className='desc-list'>
            <li>Assess</li>
            <li>Implement</li>
            <li>Monitoring</li>
          </ul>
        </div>
      </div>
    </div>
  )
}